import { PolylineEdge, PolylineEdgeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';

/**
 * DataInputAssociation / DataOutputAssociation — BPMN 2.0 dotted arrow
 * connecting DataObjects to/from activities.
 *
 * Visual: dashed line with open arrow head at the target end.
 */

class DataAssociationView extends PolylineEdge {
  getEndArrow() {
    const { model } = this.props;
    const { stroke } = model.getEdgeStyle();
    return h('path', {
      d: 'M 0 0 L 10 -5 L 10 5 Z',
      fill: 'none',
      stroke: stroke || '#555',
      strokeWidth: 1,
    });
  }
}

class DataAssociationModel extends PolylineEdgeModel {
  initEdgeData(data) {
    super.initEdgeData(data);
    this.text = { ...this.text, draggable: true };
  }

  getEdgeStyle() {
    const style = super.getEdgeStyle();
    const t = getThemeStyle(this.graphModel, 'dataAssociation');
    style.stroke = t.stroke || '#555';
    style.strokeWidth = t.strokeWidth ?? 1;
    style.strokeDasharray = '4,4';
    return style;
  }

  getTextPosition() {
    const pos = super.getTextPosition();
    if (isNaN(pos.x) || isNaN(pos.y)) {
      return { x: 0, y: 0 };
    }
    return pos;
  }
}

export const DataInputAssociation = {
  type: 'epx:DataInputAssociation',
  view: DataAssociationView,
  model: DataAssociationModel,
};

export const DataOutputAssociation = {
  type: 'epx:DataOutputAssociation',
  view: DataAssociationView,
  model: DataAssociationModel,
};
